import { clearFeatures, disableFeature, enableFeature, resetFeature } from 'Cloud/Application/FeaturesEs6';
import config from 'Cloud/config';

const FEATURES = config.get('FEATURES');

export function manageFeatures(arg1?: any, arg2?: any) {
    let featuresNamesToValues: Record<string, any> | (() => Record<string, any>) = {};
    let mode: string | number = 1;

    if (arg1 !== undefined) {
        featuresNamesToValues = arg1;

        if (arg2 !== undefined) {
            if (typeof arg1 === 'number' || typeof arg1 === 'string') {
                mode = arg1;
                featuresNamesToValues = arg2;
            } else {
                mode = arg2;
                featuresNamesToValues = arg1;
            }
        }
    }

    if (typeof featuresNamesToValues === 'function') {
        featuresNamesToValues = featuresNamesToValues();
    }

    featuresNamesToValues = Object.fromEntries(Object.entries(featuresNamesToValues).filter(([name]) => !name.startsWith('^')));

    if (mode === 'echo' || mode === 5) {
        return featuresNamesToValues;
    }

    if (mode === 'echo_plain' || mode === 6) {
        // eslint-disable-next-line no-console
        console.log(JSON.stringify(featuresNamesToValues, null, 2));
        return;
    }

    if (mode === 'check' || mode === 0) {
        return Object.keys(featuresNamesToValues).reduce((acc, ftr) => {
            acc[ftr] = { enabled: FEATURES.enabled.includes(ftr), config: FEATURES.configs[ftr] };
            return acc;
        }, {});
    }

    let effect: (...args) => void = () => {};
    switch (mode) {
        case 'enable':
        case 1:
            effect = enableFeature;
            break;
        case 'disable':
        case 2:
            effect = disableFeature;
            break;
        case 'reset':
        case 3:
            effect = resetFeature;
            break;
        case 'reset-all':
        case 4:
            clearFeatures();
            effect = enableFeature;
            break;
    }
    Object.entries(featuresNamesToValues).forEach(([name, value]) => {
        effect(name, value);
    });
}
